<template>
  <section>
    <v-container fluid>
      <v-row class="justify-end align-center">
        <!-- <v-col cols="auto">
          ...
        </v-col> -->

        <v-col cols="auto" class="ml-auto">
          <v-text-field
            filled
            rounded
            dense
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>

    <v-card class="shadow-1 mt-5 mt-md-10">
      <!-- NO TOCAR. ESTA PAGINACIÓN POR SERVIDOR SI FUNCIONA -->
      <v-data-table
        :search="search"
        :headers="headers"
        :items="agentInfo"
        item-key="id"
        :loading="isLoading"
        :options.sync="options"
        :expanded.sync="expanded"
        :server-items-length="totalItems"
        :footer-props="{
          'items-per-page-options': [15, 30, 50, 100],
        }"
      >
        <template v-slot:[`item.name`]="{ item }">
          <v-list two-line max-width="350px" class="transparent my-0 py-0">
            <v-list-item class="px-0">
              <v-list-item-content class="d-block d-md-none mr-2">
                <v-list-item-title
                  class="primary--text text--darken-1 font-weight-medium"
                  v-html="item.name"
                ></v-list-item-title>
                <v-list-item-subtitle v-html="item.email"></v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-avatar size="40" tile>
                <v-badge
                  :bordered="item.online"
                  bottom
                  :color="item.online ? 'success' : 'transparent'"
                  dot
                  offset-x="10"
                  offset-y="10"
                >
                  <v-avatar size="40" :color="$vuetify.theme.dark ? 'blue-grey darken-4' : 'blue-grey lighten-5'">
                    <v-img v-if="item.url_image" :src="item.url_image" alt="Avatar del usuario"></v-img>
                    <v-icon color="blue-grey" v-else>mdi-account</v-icon>
                  </v-avatar>
                </v-badge>
              </v-list-item-avatar>

              <v-list-item-content class="d-none d-md-block ml-3">
                <v-list-item-title
                  class="primary--text text--darken-1 font-weight-medium"
                  v-html="item.name"
                ></v-list-item-title>
                <v-list-item-subtitle v-html="item.email"></v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </template>

        <template v-slot:[`item.statusExtension`]="{ item }">
          <v-chip color="transparent" small>
            {{ extensionState(item.extension) }}
          </v-chip>
        </template>

        <template v-slot:[`item.statusQueue`]="{ item }">
          <v-chip color="transparent" small>
            <v-icon left small :color="item.online !== null && item.connect === 1 ? 'success' : 'grey'"
              >mdi-radiobox-marked</v-icon
            >
            {{ item.online !== null && item.connect === 1 ? "Conectado" : "Desconectado" }}
          </v-chip>
        </template>

        <template v-slot:[`item.status`]="{ item }">
          <v-chip
            v-if="item.status == 2"
            color="transparent"
            small
            @click.stop="openConfirmClose(item.user_pause[0].id)"
          >
            <v-icon left small :color="statusColor(item.status)">mdi-radiobox-marked</v-icon>
            {{ item.status | StatusName }}
          </v-chip>

          <v-chip v-else-if="item.status == 3" color="transparent" small @click.stop="UnlockAgent(item.lock_user.id)">
            <v-icon left small :color="statusColor(item.status)">mdi-radiobox-marked</v-icon>
            {{ item.status | StatusName }}
          </v-chip>

          <v-chip v-else color="transparent" small>
            <v-icon left small :color="statusColor(item.status)">mdi-radiobox-marked</v-icon>
            {{ item.status | StatusName }}
          </v-chip>
        </template>

        <template v-slot:[`item.extension`]="{ item }">
          <span :class="[item.extension === null ? 'text--secondary' : '']">{{
            item.extension !== null ? item.extension : item.extension_opcional ? item.extension_opcional : item.variable
          }}</span>
          <v-icon v-if="item.variable" small class="ml-1" color="grey">mdi-dice-3</v-icon>
        </template>

        <template v-slot:[`item.action`]="{ item }">
          <v-hover v-slot:default="{ hover }">
            <v-btn text icon :color="hover ? 'accent' : 'blue-grey'" @click.stop="openRangeDialog(item.id, item.name)">
              <v-icon>mdi-eye</v-icon>
            </v-btn>
          </v-hover>
        </template>
      </v-data-table>
    </v-card>

    <!-- Componentes -->

    <!-- Componente Global Seleccion de Fecha -->
    <date-range-picker
      :active="rangeDialogActive"
      :id="agentSelectedId"
      module="agentTimeline"
      @dialog:change="handleDateRangeDialog"
    />

    <!-- Diálogo Historial del Agente -->
    <v-dialog v-model="timelineDialog" persistent scrollable max-width="800">
      <ValidationObserver ref="obs" v-slot="{ passes }">
        <v-card>
          <v-card-title class="pa-0 shadow-1">
            <v-img
              :src="require('@/assets/illustrations/bg_modal_card.svg')"
              cover
              position="left bottom"
              class="align-center"
              height="65px"
            >
              <v-card-title class="font-weight-medium primary--text">
                Historial de {{ agentSelectedName }}
              </v-card-title>
            </v-img>
          </v-card-title>

          <vuescroll
            :ops="{
              bar: { background: '#bacfcec0', keepShow: true },
            }"
          >
            <v-card-text style="max-height: 800px">
              <v-timeline v-if="agentHistory.length > 0" align-top dense>
                <v-timeline-item
                  class="pb-0"
                  v-for="item in agentHistory"
                  :key="item.id"
                  :fill-dot="!typeAction(item.action_type_id).small"
                  :small="typeAction(item.action_type_id).small"
                  :color="typeAction(item.action_type_id).color"
                  :icon="typeAction(item.action_type_id).icon"
                >
                  <div class="d-flex">
                    <div>
                      <strong class="me-4">{{ item.created_at | dateFormat }}</strong>
                      <p>{{ item.created_at | getHourFormat }}</p>
                    </div>
                    <div>
                      <strong>{{ item.action.name }}</strong>
                      <div class="text-caption">
                        {{ item.action.description }}
                      </div>
                    </div>
                  </div>
                </v-timeline-item>
              </v-timeline>

              <p v-else>
                Sin actividad en el tiempo consultado.
              </p>
            </v-card-text>
          </vuescroll>

          <v-divider></v-divider>

          <v-card-actions class="mx-2">
            <v-spacer></v-spacer>
            <v-hover v-slot:default="{ hover }">
              <v-btn text rounded class="mr-1" :color="hover ? 'error' : 'grey'" @click="closedRangeDialog"
                >Cerrar</v-btn
              >
            </v-hover>
          </v-card-actions>
        </v-card>
      </ValidationObserver>
    </v-dialog>
  </section>
</template>

<script>
import vuescroll from "vuescroll";
import axios from "axios";
import { PbxHttpClient } from "@/services/httpclient";
import { getTimeTillNow } from "@/components/Utils/timeHelpers";
import DateRangePicker from "@/components/DatePickers/DateRangePicker.vue"; // Componente Global

export default {
  name: "AgentList",

  components: {
    vuescroll,
    DateRangePicker, // Registrando Componente Global
  },

  data() {
    return {
      isLoading: false,
      rangeDialogActive: false,
      timelineDialog: false,
      statusFilter: 1,
      search: "",
      expanded: [],
      // For pagination
      totalItems: 0,
      options: {
        page: 1,
        itemsPerPage: -1,
      },
      // End for pagination
      agentInfo: [],
      newExtensionList: [],
      agentInfoBackup: [],
      active: false,
      editUser: {},
      headers: [
        {
          text: "Agente",
          align: "left",
          value: "name",
          class: "primary--text",
          width: "40%",
        },
        {
          text: "Extensión",
          value: "extension",
          class: "primary--text",
          width: "40%",
        },
        {
          text: "Acciones",
          value: "action",
          class: "primary--text",
          width: "15%",
          align: "left",
          sortable: false,
        },
      ],
      // DESBLOQUEAR AGENTE
      Agent: {},
      comment: "",
      showComment: false,
      // DESPAUSAR AGENTE
      pauseToDelete: null,
      isConfirmDialog: false,
      breaksList: [],
      dates: {},
      agentSelectedId: null,
      agentHistory: [],
    };
  },

  watch: {
    options: {
      handler() {
        this.getAgents();
      },
      deep: true,
    },

    statusFilter() {
      this.getAgents();
      this.getNewExtensionList();
    },
  },

  computed: {
    breaks() {
      return this.$store.getters["breaks/GET_BREAK_LOCK"];
    },
  },

  async created() {
    await this.getBreaks();
    await this.getBreaks2();
  },

  mounted() {
    this.getNewExtensionList();
    this.getAgents();
  },

  methods: {
    // --- NUEVO MANEJADOR DEL DIALOGO GLOBAL ---
    handleDateRangeDialog(value, parameters) {
      if (value === "cerrar") {
        this.rangeDialogActive = false;
        this.agentSelectedId = null;
        this.agentSelectedName = null;
      } else if (value === "agentTimeline") {
        // Recibe las fechas emitidas por el componente global
        this.dates.date = parameters.start;
        this.dates.dateEnd = parameters.end;
        this.eventdialog("consultar");
      }
    },
    // ------------------------------------------

    openRangeDialog(agentId, agentName) {
      this.rangeDialogActive = true;
      this.agentSelectedId = agentId;
      this.agentSelectedName = agentName;
    },

    closedRangeDialog() {
      this.timelineDialog = false;
      this.agentSelectedId = null;
      this.agentSelectedName = null;
    },

    getTimeTillNowFromItem(item) {
      const pauseUpdatedAt = item.user_pause[0]?.updated_at;
      if (!pauseUpdatedAt) return "--";
      return getTimeTillNow(pauseUpdatedAt);
    },

    reloadPage() {
      this.getAgents();
      this.getNewExtensionList();
    },

    statusColor(status) {
      let color;

      switch (status) {
        case 0:
          color = "error";
          break;
        case 1:
          color = "success";
          break;
        case 2:
          color = "light-blue";
          break;
        case 3:
          color = "warning";
          break;
      }
      return color;
    },

    typeAction(type) {
      let value;

      switch (type) {
        case 0:
          value = { small: true, icon: "", color: "success" };
          break;
        case 1:
          value = { small: false, icon: "mdi-coffee", color: "info" };
          break;
        case 2:
          value = { small: false, icon: "mdi-phone-incoming", color: "primary" };
          break;
        case 3:
          value = { small: false, icon: "mdi-phone-outgoing", color: "secondary" };
          break;
        case 4:
          value = { small: false, icon: "mdi-secondary", color: "secondary" };
          break;
        case 5:
          value = { small: false, icon: "mdi-tag", color: "amber" };
          break;
        case 6:
          value = { small: false, icon: "mdi-message-check", color: "teal" };
          break;
        case 7:
          value = { small: true, icon: "", color: "teal" };
          break;
        case 8:
          value = { small: true, icon: "", color: "teal" };
          break;
        case 9:
          value = { small: false, icon: "mdi-message-off", color: "teal" };
          break;
        case 10:
          value = { small: false, icon: "mdi-coffee-off", color: "pink" };
          break;
        case 11:
          value = { small: true, icon: "", color: "purple" };
          break;
        case 12:
          value = { small: true, icon: "", color: "purple" };
          break;
        case 13:
          value = { small: false, icon: "mdi-coffee", color: "info" };
          break;
        case 14:
          value = { small: true, icon: "", color: "indigo" };
          break;
        case 15:
          value = { small: false, icon: "mdi-list-box", color: "brown" };
          break;
        case 16:
          value = { small: false, icon: "mdi-calendar-clock", color: "light-green darken-3" };
          break;
        case 17:
          value = { small: true, icon: "", color: "error" };
          break;
      }
      return value;
    },

    dateFormat(date) {
      const dateFormatted = date
        .toString()
        .slice(0, 10)
        .split("-")
        .reverse()
        .join("/");
      return dateFormatted;
    },

    extensionState(agentExtension = null) {
      let item = null,
        status;
      const state = this.newExtensionList.filter((item) => item.ext == agentExtension);

      if (state.length > 0) item = state[0].status;

      switch (item) {
        case "Ring":
          status = "Ring";
          break;
        case "Up":
          status = "En llamada";
          break;
        default:
          status = "Libre";
      }

      return status;
    },

    async eventdialog(data) {
      this.rangeDialogActive = false; // Se oculta el componente global tras presionar "Buscar" o "Consultar"
      if (data !== "cerrar") {
        this.isLoading = true;
        try {
          const { data } = await PbxHttpClient.get(
            `/generate-report-user?start_date=${this.dates.date}&end_date=${this.dates.dateEnd}&user_id=${this.agentSelectedId}`,
          );

          if (data.data.length > 0 && data.data[0]?.logs !== undefined) {
            const loginObject = {
              action: { id: 0, name: "Inicio de sesión", description: "Entró al sistema." },
            };
            const logoutObject = {
              action: { id: 17, name: "Cerró sesión", description: "El agente salió del sistema." },
            };

            this.agentHistory = data.data[0].logs;

            const dailyLogs = data.data[0].daily.flatMap((item) => [
              {
                created_at: item.check_in,
                action_type_id: 0,
                action: loginObject.action,
                user_id: item.user_id,
              },
              {
                created_at: item.updated_at,
                action_type_id: 17,
                action: logoutObject.action,
                user_id: item.user_id,
              },
            ]);

            this.agentHistory = [...this.agentHistory, ...dailyLogs].sort(
              (a, b) => new Date(a.created_at) - new Date(b.created_at),
            );
          } else {
            this.agentHistory = [];
          }

          this.timelineDialog = true;
        } catch (err) {
          console.log("Error:", err);
        } finally {
          this.isLoading = false;
        }
      }
    },

    findDurationByExt(extension) {
      const matchingItem2 = this.newExtensionList.find((item) => item.ext === extension);
      if (matchingItem2) {
        if (matchingItem2.duration) {
          return matchingItem2.duration + "s";
        }
      }
      return "--";
    },

    // DESBLOQUEAR AGENTE
    UnlockAgent(item) {
      this.showComment = true;
      this.Agent = item;
    },

    async unlockConfirm() {
      const enviar = {
        comment: {
          comment: this.comment,
        },
        id: this.Agent,
      };
      const response = await this.$store.dispatch("breaks/UNLOCK_AGENTS", enviar);
      this.showComment = false;
      alert(response.data.message);

      this.reloadPage();
    },

    // QUITAR PAUSA AGENTE
    openConfirmClose(pauseId) {
      this.pauseToDelete = pauseId;
      this.isConfirmDialog = true;
    },

    async getBreaks2() {
      try {
        const response = await this.$store.dispatch("breaks/SHOW_AGENTS_BREAKS_LOCK");
      } catch (error) {
        console.log(error);
      }
    },

    async getBreaks() {
      try {
        const { data } = await PbxHttpClient.get("/agent/use_pause/");
        this.breaksList = data.data;
      } catch (error) {
        this.$snotify.error("Hubo un error en la consulta", "Error");
      }
      this.isLoadingTable = false;
    },

    async closePause() {
      this.isLoading = true;
      try {
        await PbxHttpClient.put(`/agent/use_pause/${this.pauseToDelete}`);
        this.breaksList = this.breaksList.filter((e) => e.pause_id !== this.pauseToDelete);
        this.pauseToDelete = null;
        this.$snotify.success("Pausa cerrada con éxito.", "¡Hecho!");
        this.isConfirmDialog = false;
        this.reloadPage();
      } catch (err) {
        this.$snotify.error("Hubo un error cerrando la pausa", "Error");
      }

      this.isLoading = false;
    },

    /**
     * Busca la lista de agentes
     *
     * @param {Number} page - Numero de pagina a mostrar
     */
    getAgents() {
      this.$store.commit("layout/SET_OVERLAY", {
        value: true,
        title: "Cargando",
      });
      this.isLoading = true;

      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      const accessToken = localStorage.getItem("token");

      axios
        .get(`${process.env.VUE_APP_ROOTAPI}/clients/show/agents?page=${page}&itemPerPage=${itemsPerPage}`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        })
        .then((res) => {
          this.agentInfo = res.data.data;
          this.agentInfoBackup = res.data.data;
          this.totalItems = res.data.total;
        })
        .catch((error) => {
          this.$snotify.error("Hubo un error en la consulta.", "Error");
        })
        .finally(() => {
          this.isLoading = false;
          this.$store.commit("layout/SET_OVERLAY", { value: false, title: "" });
        });
    },

    async getNewExtensionList() {
      try {
        const { data } = await PbxHttpClient.get(`/manager/extension_new`);
        this.newExtensionList = data.data;
      } catch (err) {
        this.$snotify.error("Hubo un error consultando las extensiones.", "¡Error!");
      }
    },

    async changeStatus(value) {
      const conf = confirm("CAMBIAR ESTATUS");
      if (conf) {
        try {
          if (value.status === 2) {
            await this.$store.dispatch("user/QUIT_PAUSE", {
              id: value.user_pause[0].id,
            });
          } else {
            await this.$store.dispatch("user/CHANGE_STATUS", {
              id: value.id,
            });
          }

          this.$snotify.success("Estatus cambiado con éxito.", "¡Hecho!");

          this.getAgents();
        } catch (error) {
          this.$snotify.error("No se pudo cambiar el estado del usuario.", "¡Error!");
        }
      }
    },

    handleEdit(user) {
      if (user.connect === 1) {
        this.$snotify.warning("No se puede editar un usuario conectado.", "Espera");
      } else {
        this.editUser = {
          id: user.id,
          name: user.name,
          email: user.email,
          extension: user.extension,
          variable: user.variable,
          queues: user.queues,
          priority_order: user.priority_order,
          role_id: user.role_id,
          auto_connection: user.auto_connection,
          extension_opcional: user.extension_opcional,
        };
        this.active = true;
      }
    },

    async handleLogoutPlanta(id, name) {
      const accessToken = localStorage.getItem("token");

      const confirmRequest = await this.$swalconfirm("Logout", `Está seguro de cerrar sesión a ${name}.`);

      if (confirmRequest.isConfirmed) {
        axios
          .get(`${process.env.VUE_APP_ROOTAPI}/authServer/desconnect/${id}`, {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          })
          .then((res) => {
            if (res.status === 200) {
              for (const client of res.data) {
                switch (client.codigo) {
                  case "Command":
                    this.$snotify.error(`Cola ${client.queue}: ${client.message}`, "¡Error!");
                    break;
                  case "Removed":
                    this.$store.commit("passport/UPDATE_CONNECTION_AGENT", 0);
                    this.$snotify.success(`${client.message}`, `Cola ${client.queue}`);
                    break;
                }
              }
              this.getAgents();
            }
          })
          .catch((error) => {
            this.$snotify.error("No se pudo desconectar de la planta.", "Error");
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },

    async handleLogoutSystem(id) {
      const accessToken = localStorage.getItem("token");
      axios
        .post(`${process.env.VUE_APP_ROOTAPI}/assistance/logoutAdmin/${id}`, "", {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        })
        .then((res) => {
          this.getAgents();
          this.$snotify.success("Sesión finalizada.", "¡Hecho!");
        })
        .catch((error) => {
          this.$snotify.error("No se pudo cerrar sesión de este usuario.", "Error");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
